<div class="product-component container-fluid mt-2 form-fulll-container">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
  <div class="row mt-4">
    <div class="col-3 profile-container">
      <h2 class="profile-title profile-container">{{ 'AUTHORIZATION.MY_ACCOUNT' | translate }}</h2>
      <div class="profile-container">
        <img class="profile-image" src="assets/img/icons/profile-image.png" />
        <h2 class="profile-username">{{ passListData?.name | labelSanitizer }}</h2>
        <p class="profile-user-name">{{ role |translate }}</p>

        <div class="mt-4">
          <p class="mb-2 mt-2 text-left profile-url" (click)="redirectToProfile(0)">{{
            translationKeys.UserProfiles.ProfileDetails | translate }}</p>
          <mat-divider></mat-divider>
          <p class="mb-2 mt-2 text-left profile-url" (click)="redirectToProfile(5)" *ngIf="isNotHartmannUser">{{
            translationKeys.UserProfiles.ChangePassword | translate }}</p>
          <mat-divider></mat-divider>
        </div>

        <div class="container mt-2 p-0 profile-signout">
          <button (click)="logout()" class="btn-bd expand-button">
            {{ translationKeys.UserProfiles.Signout | translate }}</button>
        </div>
      </div>
    </div>
    <div class="col-9 profile-page">
      <div class="d-flex justify-content-end">
        <a class="cursor edit-icon">
          <mat-icon style="color: black !important; opacity: .54;"
            class="mat-icon notranslate material-icons mat-icon-no-color cursor icon-size-24" role="img"
            aria-hidden="true" (click)="onBack()">close</mat-icon>
        </a>
      </div>
      <!-- <h2 class="d-flex  align-items-center m-0">
            <span class="ref" (click)="onBack()">
                    <i class="material-icons">
                        arrow_back_ios
                    </i>
                </span>
                <span class="facility">My Profile</span></h2> -->
      <mat-tab-group [selectedIndex]="selectIndex">
        <mat-tab label="Profile details">
          <!-- <dhhp-card class="profile"> -->
          <mat-card class="profile-common-card-container">
            <div class="row">

              <div class="col-xs-12 col-md-12 col-lg-12 col-xl-12">
                <div class="row">
                  <div class="col-xs-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="d-flex justify-content-end">
                      <a class="cursor edit-icon editIcon">
                        <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color icon-size-24"
                          [ngClass]="{'hideEdit': hideEditVal}" role="img" aria-hidden="true" (click)="onEdit()"
                          *ngIf="isNotHartmannUser">edit</mat-icon>
                        <mat-icon class="info ml-auto" [outsideClick]="true" [popover]="popTemplatehart" placement="top"
                          *ngIf="!isNotHartmannUser">info</mat-icon>
                        <ng-template #popTemplatehart>
                          <div>
                            <div class="col">
                              <div class="p-2 h-200">
                                {{"GENERAL.CONTACT_ADMIN_FOR_PROFILE_DETAIL_CHANGE" | translate }}
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </a>
                    </div>
                    <div class="bd-input mt-2 mb-4">
                        <input type="text" id="input" required="" inputSanitizer maxlength="100" 
                        class="" #inputNameModel="ngModel" 
                        [(ngModel)]="name" 
                        [ngClass]="{ 'is-invalid':  submitted && inputNameModel.invalid }"
                        [disabled]="mode =='View'"
                        (ngModelChange)="changeNameText($event)">
                        <label for="input" class="label" [ngClass]="!name ? '':'filled' " >{{ translationKeys.ProfileDetails.Name | translate }} </label>
                        <div class="underline"></div>
                        <div *ngIf="submitted && inputNameModel?.errors" class="invalid-feedback">
                          <div *ngIf="inputNameModel.errors?.required">
                            {{ translationKeys.ProfileDetails.NameRequired | translate }}
                          </div>
                        </div>
                    </div>

                    <!-- <div class="form-group">
                      <label>{{ translationKeys.ProfileDetails.Name | translate }} </label>
                      <p class="mt-1" *ngIf="mode =='View'">
                        {{((currentUserData.salutation) ? (currentUserData.salutation+ " ") : "") +
                        currentUserData?.name}}
                      </p>
                      <input inputSanitizer type="text" #inputNameModel="ngModel" [(ngModel)]="name"
                        *ngIf="mode =='Edit'" class="form-control"
                        [ngClass]="{ 'is-invalid':  submitted && inputNameModel.invalid }" required>
                      <div *ngIf="submitted && inputNameModel?.errors" class="invalid-feedback">
                        <div *ngIf="inputNameModel.errors?.required">
                          {{ translationKeys.ProfileDetails.NameRequired | translate }}
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <div class="col-xs-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                    <div class="bd-input mt-4">
                      <input type="text" id="input" required="" inputSanitizer maxlength="100" 
                      class="" #inputEmailModel="ngModel" 
                      [(ngModel)]="email" class=""
                      [ngClass]="{ 'is-invalid':  submitted && inputEmailModel.invalid }"
                      [pattern]="'^[a-zA-Z]{1}[a-zA-Z0-9.\-_]*@[a-zA-Z]{1}[a-zA-Z.-]*[a-zA-Z]{1}[.][a-zA-Z]{2,}$'"
                      [disabled]="mode =='View'"
                      (ngModelChange)="changeEmailText($event)">
                      <label for="input" class="label" [ngClass]=" !email ? '':'filled' " >{{ translationKeys.ProfileDetails.Email |translate}} </label>
                      <div class="underline"></div>
                      <div *ngIf="submitted && inputEmailModel?.errors" class="invalid-feedback">
                        <div *ngIf="inputEmailModel.errors?.required">
                          {{ translationKeys.ProfileDetails.MailRequired |translate}}
                        </div>
                        <div *ngIf="inputEmailModel.errors?.pattern">
                          {{'ERROR_MESSAGES.INVALID_EMAIL_FORMAT' | translate}}
                        </div>
                      </div>
                  </div>

                    <!-- <div class="form-group">
                      <label>{{ translationKeys.ProfileDetails.Email |translate}}
                      </label>
                      <p class="mt-1" *ngIf="mode =='View'">
                        {{(currentUserData.email ? currentUserData.email : '--') | labelSanitizer}}</p>
                      <input inputSanitizer type="text" #inputEmailModel="ngModel"
                        [pattern]="'^[a-zA-Z]{1}[a-zA-Z0-9.\-_]*@[a-zA-Z]{1}[a-zA-Z.-]*[a-zA-Z]{1}[.][a-zA-Z]{2,}$'"
                        [(ngModel)]="email" *ngIf="mode =='Edit'" class="form-control" aria-describedby="Email"
                        [ngClass]="{ 'is-invalid':  submitted && inputEmailModel.invalid }" required>
                      <div *ngIf="submitted && inputEmailModel?.errors" class="invalid-feedback">
                        <div *ngIf="inputEmailModel.errors?.required">
                          {{ translationKeys.ProfileDetails.MailRequired |translate}}
                        </div>
                        <div *ngIf="inputEmailModel.errors?.pattern">
                          {{'ERROR_MESSAGES.INVALID_EMAIL_FORMAT' | translate}}
                        </div>
                      </div>
                    </div> -->



                  </div>
                  <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6" *ngIf='!isPlatform && !isDisableSetting'>
                    <div class="form-group">
                      <label>{{'GENERAL.FACILITY'|translate}}
                        <!-- <span class="mandatory">*</span> -->
                      </label>
                      <p class="mt-1">{{(institutionname ? institutionname : '--') | labelSanitizer}}</p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 mt-1 mb-3">
                    <div class="form-group">
                      <label>{{ translationKeys.ProfileDetails.Role | translate }}
                        <!-- <span class="mandatory">*</span> -->
                        <mat-icon class="info ml-auto" [outsideClick]="true" [popover]="popTemplate1" placement="top"
                          *ngIf="isNotHartmannUser">
                          info</mat-icon>
                        <ng-template #popTemplate1>
                          <div>
                            <div class="col">
                              <div class="p-2 h-200">
                                {{'AUTHORIZATION.FOR_ROLE_CHANGE_CONTACT_ADMINISTRATOR' | translate }}
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </label>
                      <p class="mt-1" *ngIf='!isPlatform'>{{role ? (role | translate | labelSanitizer) : '--'}}</p>
                      <p class="mt-1" *ngIf='isPlatform'>
                        {{currentUserData.role ?(currentUserData.role | translate | labelSanitizer) : '--'}}

                      </p>

                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 mt-1" *ngIf="isNotHartmannUser">
                    <div class="form-group">
                      <label>{{ translationKeys.Authorization.Username | translate }}
                        <!-- <span class="mandatory">*</span> -->
                        <mat-icon class="ml-2 info ml-auto" [outsideClick]="true" [popover]="popTemplate2"
                          placement="top">info</mat-icon>
                        <ng-template #popTemplate2>
                          <div>
                            <div class="col">
                              <div class="p-2 h-200">
                                {{ 'AUTHORIZATION.USERNAME_CANNOT_BE_CHANGED' | translate }}
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </label>
                      <p class="mt-1">{{currentUserData.username | labelSanitizer}}</p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6" *ngIf="(isNotHartmannUser && !isDisableSetting )">
                    <div class="form-group">
                      <label>{{'GENERAL.ACCOUNT_NUMBER'|translate}}
                        <!-- <span class="mandatory">*</span> -->
                      </label>
                      <p class="mt-1 mb-1" *ngFor="let acc of getAccountData">
                        {{acc.facilitySAPId}}</p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6"
                    *ngIf="(isNotHartmannUser && !isDisableSetting ) || (isDisableSetting && institutionname?.length > 0)">
                    <div class="form-group">
                      <label>{{ translationKeys.ProfileDetails.InstitutionName | translate }}
                        <!-- <span class="mandatory">*</span> -->
                      </label>
                      <span *ngIf="!isDisableSetting">
                        <p class="mt-1 mb-1" *ngFor="let account of getAccountData">

                          {{account.facilityName | labelSanitizer}}</p>
                      </span>
                      <span *ngIf="isDisableSetting">
                        <p class="mt-1 mb-1" *ngFor="let account of institutionname">
                          {{account?.label}}</p>
                      </span>
                    </div>
                  </div>

                  <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6" *ngIf='!isPlatform && !isDisableSetting'>
                    <div class="form-group">
                      <label>{{'GENERAL.EMPLOYMENT_STATUS'|translate}}
                        <!-- <span class="mandatory">*</span> -->
                      </label>
                      <p class="mt-1">{{employeeStatus ? (employeeStatus | translate | labelSanitizer) : '--'}}</p>
                    </div>
                  </div>
                </div>
                <!-- <label>Subscription</label> -->
                <div class="row" *ngIf="false">
                  <div class="col-12">
                    <div class="table-responsive">
                      <table mat-table class="mat-elevation-z8 col-12 pt-3" [dataSource]="dataSource">
                        <ng-container matColumnDef="appName">
                          <th mat-header-cell *matHeaderCellDef>{{'GENERAL.APPNAME' | translate}}</th>
                          <td mat-cell *matCellDef="let element">
                            <div class="name-ellipsis" title="{{element.name}}">
                              {{element.appName}} </div>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="appRole">
                          <th mat-header-cell *matHeaderCellDef>{{ translationKeys.ProfileDetails.Role | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element"> {{element.appRole}} </td>
                        </ng-container>



                        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row">
                        </tr>
                      </table>
                      <div *ngIf="isNotFound" class="text-center">
                        <p>{{'CONFIGURE.NO_RECORDS' | translate}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-card>
          <!-- </dhhp-card> -->
          <div class="col-12 col-lg-12 mt-3 p-0" *ngIf="mode =='Edit'">
            <div class="form-group text-right d-flex justify-content-end">
              <button type="submit" color="accent" class="btn-cancel-bordered-bd card-header-action mr-3"
                (click)="onCancel($event)">{{ translationKeys.Authorization.Cancel | translate }}</button>
              <button color="primary" class="btn-bd card-header-action"
                (click)="onSave($event, imageUploaderComp);">{{ translationKeys.Authorization.Save | translate
                }}</button>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Change password" *ngIf="isNotHartmannUser">
          <app-change-password [clientId]="clientId" [clientSecret]="clientSecret"
            [username]="currentUserData?.username" (dataEvent)="onDataEvent($event)" [logOutUrl]="logOutUrl">
          </app-change-password>
        </mat-tab>
        <!-- <mat-tab label="Delete my account" *ngIf="isNotHartmannUser">
                    <app-delete-account [passAppList]="passListData" [userprinciplename]="userprinciplename"
                        (dataEvent)="onDataEvent($event)" [logOutUrl]="logOutUrl"></app-delete-account>
                </mat-tab> -->
      </mat-tab-group>
    </div>
  </div>
</div>

<ng-template #confirmModal>
  <div class="modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a (click)="modalRef.hide()" data-dismiss="modal" class="cursor"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body" >
    <p class="lead">
      {{'AUTHORIZATION.CONFIRM_CANCELED_ACCEPTANCE' | translate}}
    </p>
  </div>
  <div class="modal-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col my-3 justify-content-center align-items-center d-flex">
          <button (click)="modalRef.hide()" class="btn btn-cancel mr-4">{{ 'INSTITUTION_MANAGEMENT.NO' | translate
            }}</button>
          <button (click)="decline();modalRef.hide();" class="bd-btn">{{ 'INSTITUTION_MANAGEMENT.YES' |
            translate }}</button>
        </div>
      </div>
    </div>
  </div>

</ng-template>